module.exports = __webpack_public_path__ + "img/screen.9ede5552.png";